import { jsx } from 'react/jsx-runtime';
import { useEffect } from 'react';
import { useField } from 'formik';
import { Checkbox } from '../Checkbox/Checkbox.js';

function CheckboxField({
  name,
  validate,
  ...rest
}) {
  const [field, meta, {
    setValue,
    setError
  }] = useField({
    name,
    validate
  });
  function handleChange(value) {
    if (rest.onCheckedChange) {
      rest.onCheckedChange(value);
    }
    setValue(value);
  }
  useEffect(() => {
    return () => {
      setValue(undefined);
      setError(undefined);
    };
  }, []);
  return jsx(Checkbox, {
    ...field,
    ...rest,
    hasError: Boolean(meta.touched && meta.error),
    id: name,
    checked: field.value,
    onChange: handleChange
  });
}

export { CheckboxField };
